import { v4 as uuidv4 } from 'uuid';

/**
 * Quy ước trục local của module (khi chưa xoay):
 *  - Z: chiều rộng (width)
 *  - Y: chiều cao (height)
 *  - X: chiều sâu (depth)
 * 1 đơn vị Three.js = 1 mét.
 */
export const DIM_AXIS = {
  WIDTH: 'width',
  HEIGHT: 'height',
  DEPTH: 'depth',
  // Đo thẳng giữa hai điểm (không khoá theo trục nào của module)
  CUSTOM: 'custom',
};

/** Trục local (x|y|z) tương ứng với từng loại kích thước. */
export const DIM_AXIS_TO_LOCAL = {
  [DIM_AXIS.WIDTH]: 'z',
  [DIM_AXIS.HEIGHT]: 'y',
  [DIM_AXIS.DEPTH]: 'x',
};

export const DIM_TYPE = {
  LINEAR: 'linear',
  ANNOTATION: 'annotation',
};

export const DIM_GROUP = {
  OVERALL: 'overall',
  UPPER: 'upper',
  LOWER: 'lower',
  DETAIL: 'detail',
  ACCESSORY: 'accessory',
};

export const DEFAULT_DIM_STYLE = {
  color: '#C62828',
  fontSize: 10,
  lineWidth: 1.25,
  arrowType: 'arrow',
  decimals: 0,
};

/** Khoảng cách mặc định từ cạnh vật tới đường DIM (mét). */
export const DEFAULT_OFFSET_M = 0.1;

export const createDimension = (partial = {}) => ({
  id: `dim_${uuidv4()}`,
  type: DIM_TYPE.LINEAR,
  anchors: [],
  axis: DIM_AXIS.WIDTH,
  // Trục local mà đường DIM được đẩy ra theo (x|y|z) và chiều (+1/-1)
  offsetAxis: 'y',
  offsetSign: 1,
  offsetM: DEFAULT_OFFSET_M,
  labelShift: [0, 0],
  group: DIM_GROUP.DETAIL,
  visible: true,
  orphan: false,
  ...partial,
  style: { ...DEFAULT_DIM_STYLE, ...(partial.style || {}) },
});
